import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5226160f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "limit-custom-chip-content" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value" }, "200000", -1))
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_x = _resolveComponent("icon-x")!

  return (_openBlock(), _createElementBlock("div", {
    class: "limit-custom-chip-root",
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('game.tablelimit')), 1),
        _createVNode(_component_icon_x, {
          class: "close",
          onClickPassive: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('game.stationlimit')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t('common.min')), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.limit?.Min ?? ''), 1)
        ]),
        (_ctx.gameType === 1 || false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('common.pairmax')), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.limit?.PairMaxBet ?? ''), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('common.tiemax')), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.limit?.TieMaxBet ?? ''), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t('common.max')), 1),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.limit?.Max ?? ''), 1)
        ])
      ])
    ])
  ]))
}